import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import { useTranslation } from "react-i18next";

import { FooterStyles } from "./Footer.style";

interface FooterProps {
  showHome?: boolean;
  showAdmin?: boolean;
  showLogout?: boolean;
}

export const Footer: React.FC<FooterProps> = (props) => {
  const styles = FooterStyles();
  const { t } = useTranslation();
  const titleHome = t("title");
  const titleAdmin = t("admin.title");
  const titleLogout = t("logout.title");

  const showHome = () => {
    if (props.showHome) {
      return (
        <Tooltip title={titleHome} placement="top">
          <Link to="/">
            <HomeIcon color="primary" />
          </Link>
        </Tooltip>
      );
    }
  };
  const showAdmin = () => {
    if (props.showAdmin) {
      return (
        <Tooltip title={titleAdmin} placement="top">
          <Link to="/admin">
            <SettingsIcon color="primary" />
          </Link>
        </Tooltip>
      );
    }
  };
  const showLogout = () => {
    if (props.showLogout) {
      return (
        <Tooltip title={titleLogout} placement="top">
          <Link to="/logout">
            <MeetingRoomIcon color="primary" />
          </Link>
        </Tooltip>
      );
    }
  };

  return (
    <div className={styles.footer}>
      <div>
        {showHome()}
        {showAdmin()}
      </div>
      <div className={styles.user}>{showLogout()}</div>
    </div>
  );
};
